import React from 'react'
import PropTypes from 'prop-types'
import { mdiInformationOutline } from '@mdi/js'

import Text from '../../../../Components/Formik/Text'

const CoVPercentageComponent = ({ translate, ...rest }) => (
  <>
    <Text
      name="reporting.value"
      label={translate('labels.covAcceptable')}
      accessoryText={`% ${translate('labels.covLastKnown')}`}
      prefixText="+/-"
      textHelper={translate('labels.covPercentageHelper')}
      hasTooltip
      tooltipIcon={mdiInformationOutline}
      tooltipContent={translate('labels.covRangeTooltip')}
      type="number"
      min="1"
      max="20"
      data-testid="cov-percentage-input"
      {...rest}
    />
  </>
)

CoVPercentageComponent.propTypes = {
  translate: PropTypes.func.isRequired
}

export default CoVPercentageComponent
